import React from "react";
import { createRoot } from "react-dom/client";
import { IntlProvider } from "react-intl";
import DashApp from "./DashApp";
import reportWebVitals from "./reportWebVitals";
import Greek from "./lang/el.json";

const locale = "el"; // navigator.language;
// Hot Module Replacement API

const lang = Greek;
const rootEl = document.getElementById("root");

const render = () => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = createRoot(rootEl!);
  root.render(
    <IntlProvider locale={locale} messages={lang}>
      <DashApp />
    </IntlProvider>,
  );
};

if (module.hot) {
  module.hot.accept("./DashApp", () => {
    setTimeout(render);
  });
}

render();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
